export default __webpack_public_path__ + "static/media/regulatory--length-limit--g1.e26aac53.png";